import { FactFunction, RuleEngine } from '@8fig/rule-engine';
import React from 'react';
import { ABTestingContext, ABTestingContextData } from './ab-testing-context';
import { Feature } from './feature';

interface ABTestingProviderParams {
  children: React.ReactNode;
  features: Feature[];
  facts: { [factName: string]: FactFunction };
}

export function ABTestingProvider({
  children,
  features,
  facts,
}: ABTestingProviderParams) {
  // TODO: use effect for features / facts changes?
  const ruleEngine = new RuleEngine({ facts });
  const value: ABTestingContextData = { features, ruleEngine };

  return (
    <ABTestingContext.Provider value={value}>
      {children}
    </ABTestingContext.Provider>
  );
}
